<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">{{ type }}</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row mt-2"></div>
    <div
      class="row align-items-center mt-2"
      v-if="type != 'My Leave of Absence Report'"
    >
      <div class="col-md-2">Company</div>
      <div class="col-md-4 pl-md-0">
        <select class="custom-select" v-model="company">
          <option value="">All</option>
          <option
            v-for="(item, i) in companies"
            :key="i"
            :value="item.CompanyName"
          >
            {{ item.CompanyName }}
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center mt-2">
      <div class="col-md-2">Year</div>
      <div class="col-md-4 pl-md-0">
        <select class="custom-select" v-model="year">
          <option value="">All</option>
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
    </div>
    <div
      class="row align-items-center mt-2"
      v-if="type != 'My Leave of Absence Report'"
    >
      <div class="col-md-2">Employee Name/ID</div>
      <div class="col-md-4 pl-md-0">
        <Select2 v-model="userId" :options="employees" />
      </div>
    </div>
    <div class="row align-items-center mt-2">
      <div class="col-md-2">Leave Name</div>
      <div class="col-md-4 pl-md-0">
        <select class="custom-select" v-model="leaveCode">
          <option value="">All</option>
          <option v-for="leave in leaves" :key="leave.Code" :value="leave.Code">
            {{ leave.Name }}
          </option>
        </select>
      </div>
      <div class="col-md-1 ml-md-4" style="max-width: fit-content">
        <button class="btn btn-primary" @click="getEmployeeLeaves">
          Search
        </button>
      </div>
      <div class="col-md-3">
        <form
          :action="backendUrl + '/EmployeeLeaveExcelReport/ExportExcel'"
          method="POST"
        >
          <input type="hidden" name="Company" :value="company" />
          <input type="hidden" name="Year" :value="year" />
          <input type="hidden" name="UserId" :value="userId" />
          <input type="hidden" name="LeaveCode" :value="leaveCode" />
          <input type="hidden" name="Type" :value="type" />
          <input type="hidden" name="Token" :value="token" />
          <button type="submit" class="btn btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Pagination -->
    <div
      class="row mt-4 align-items-center"
      v-if="employeeLeaves && employeeLeaves.length"
    >
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="employeeLeaves && employeeLeaves.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>
    <!-- /Result Empty -->

    <!-- Table List -->
    <div class="row mt-2" v-if="employeeLeaves && employeeLeaves.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <th>Leave Name</th>
                <th>Leave Calculation</th>
                <th>Leave Start Date</th>
                <th>Leave End Date</th>
                <th>Leave Days</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in employeeLeaves" :key="i">
                <td>{{ item.EmployeeID }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>{{ item.LeaveName }}</td>
                <td>{{ item.LeaveCalculation }}</td>
                <td>{{ item.LeaveStartDateDisplay }}</td>
                <td>{{ item.LeaveEndDateDisplay }}</td>
                <td>{{ item.LeaveDaysDisplay }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="employeeLeaves && employeeLeaves.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          employeeLeaves.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>


<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";

export default {
  props: ["type"],
  components: { Select2 },
  data() {
    return {
      employeeLeaves: [],
      noRecordText: config.NO_RECORD_TEXT,
      //filter
      companies: [],
      company: "",
      years: [],
      year: "",
      employees: [],
      userId: "00000000-0000-0000-0000-000000000000",
      leaves: [],
      leaveCode: "",
      //for pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    backendUrl() {
      return this.$backendUrl;
    },
  },

  watch: {
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getEmployeeLeaves();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
    company(val) {
      if (this.isManager) this.getManagerEmployees();
      else this.getEmployees();
      this.getActiveLeaveTypes();
    },
  },

  methods: {
    //filter
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getManagerEmployeeCompanies() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      let param = {
        Token: this.token,
        ManagerID: data.EmployeeID,
      };
      this.$store.state.isLoading = true;
      API.getManagerEmployeeCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let date = new Date();
      let minYear = date.getFullYear() - 2;
      this.years = [];
      for (let year = date.getFullYear(); year > minYear; year--) {
        this.years.push(year);
      }
    },
    getEmployees() {
      let param = { Token: this.token, Company: this.company };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            response.data.record.unshift({
              department: "",
              id: "00000000-0000-0000-0000-000000000000",
              text: "All",
            });
            this.employees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getManagerEmployees() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      let param = {
        Token: this.token,
        IsActive: true,
        ManagerID: data.EmployeeID,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getManagerEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            response.data.record.unshift({
              department: "",
              id: "00000000-0000-0000-0000-000000000000",
              text: "All",
            });
            this.employees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getActiveLeaveTypes() {
      let param = {
        Token: this.token,
        Company: this.company,
        Type: this.type,
      };
      this.$store.state.isLoading = true;
      API.getActiveLeaveTypes(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.leaves = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //records
    getEmployeeLeaves() {
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
        Company: this.company,
        Year: this.year,
        UserId: this.userId,
        LeaveCode: this.leaveCode,
        Type: this.type,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeLeavesReport(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employeeLeaves = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getEmployeeLeaves();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getEmployeeLeaves();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getEmployeeLeaves();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getEmployeeLeaves();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getEmployeeLeaves();
    },
  },

  created() {
    if (this.role == "admin") this.getCompanies();
    else this.getManagerEmployeeCompanies();

    this.getYears();

    if (this.isManager) this.getManagerEmployees();
    else this.getEmployees();

    this.getActiveLeaveTypes();
    this.getEmployeeLeaves();
  },
};
</script>

<style scoped>
.col-md-2 {
  max-width: 180px;
}
</style>


// WEBPACK FOOTER //
// src/components/Leave/LeaveOfAbsenceReport.vue